import React from 'react';

/**
 * DetailCareText
 * 
 * Displays the textual content for the Care section.
 * Encapsulates the "Get Notified" call to action.
 */
export const DetailCareText = ({ t }) => {
  return (
    <a id="mr_dw-purchase-cta" href="mailto:help@trackmydown.com?subject=AFD DownWash Restock Notification" target="_blank" className="shopify-buy__btn">
      {t('care.cta_text')} {/* Using 'care.cta_text' for localization */}
    </a>
  );
};
